module.exports = __webpack_public_path__ + "img/TT_Footer_Dark.25a0445d.svg";